import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { decrementVerificationCodeTimer } from 'redux/app/app.actions';

const mapState = (state) => ({
  verificationCodeTimer: state.appData.verificationCodeTimer,
  isTimerStarted: state.appData.isTimerStarted,
});

const useTimer = () => {
  const [verificationCodeInterval, setVerificationCodeInterval] =
    useState(null);

  const { verificationCodeTimer, isTimerStarted } = useSelector(mapState);
  const dispatch = useDispatch();

  const startTimer = () => {
    const interval = setInterval(() => {
      dispatch(decrementVerificationCodeTimer());
    }, 1000);
    setVerificationCodeInterval(interval);
  };

  const stopTimer = () => {
    clearInterval(verificationCodeInterval);
    setVerificationCodeInterval(null);
  };

  useEffect(() => {
    if (isTimerStarted) {
      startTimer();
    } else {
      stopTimer();
    }

    return () => {
      stopTimer();
    };
  }, [isTimerStarted]);

  return {
    verificationCodeTimer,
    isTimerStarted,
  };
};

export default useTimer;
